import React, { useState, useEffect } from 'react';
import noData from "../assets/images/no-data.png";
import Loader from "../assets/images/loader.gif";
import moment from 'moment';
import { apiCallingPost } from '../api/services';
import { ToastContainer, toast } from 'react-toastify';
import Pagination from "react-js-pagination";
import { FaRegImage } from "react-icons/fa6";
import { FaVideo } from "react-icons/fa6";
function VideoDownloadRequest() {
  const [requestVideoList, setRequestVideoList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [userIdList, setUserIdList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10);
  const [formatSelections, setFormatSelections] = useState({});
  useEffect(() => {
    requestVideo("", offset);
  }, []);
  useEffect(() => {
    const initialSelections = {};
    requestVideoList.forEach(video => {
      initialSelections[video.requestVideoDownloadId] = {
        download_original: true, // default checked
        download_mp4: false
      };
    });
    setFormatSelections(initialSelections);
  }, [requestVideoList]);

  const requestVideo = async (typeSearch, offset) => {
    setLoading(true);
    let postData = {
      max: itemsCountPerPage,
      offset: offset,
      type: typeSearch,
      textInput: "",
      requestedDate: "",
      status: ""
    };
    try {
      const response = await apiCallingPost("api/video/VideoDownloadRequestList", postData);
      const { data } = response;
      if (data.success === "1") {
        setRequestVideoList(data.result);
        setTotalCount(data.totalCount);
      } else {
        setRequestVideoList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
      setRequestVideoList([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  const statusChangeFn = async (downloadRequestIds, e) => {
    const request = downloadRequestIds.map(id => ({
      requestVideoId: id,
      download_mp4: formatSelections[id]?.download_mp4 || false,
      download_original: formatSelections[id]?.download_original || false
    }));

    let postData = {
      request: request,
      status: e,
      user_id: ""

    };

    try {
      const response = await apiCallingPost("api/video/statusChangeVideoDownload", postData);
      const { data } = response;
      if (data.success === "1") {
        requestVideo("", offset);
        toast.success("Media status successfully updated.")
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const approveAll = () => {
    if (userIdList.length < 1) {
      toast.error("Please select at least one video / image to approve.");
      return;
    }
    statusChangeFn(userIdList, "APPROVED");
  };

  const handleCheckboxChange = (e, requestVideoDownloadId) => {
    if (e.target.checked) {
      setUserIdList((prevList) => [...prevList, requestVideoDownloadId]);
    } else {
      setUserIdList((prevList) => prevList.filter((id) => id !== requestVideoDownloadId));
    }
  };

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const allCurrentPageIds = requestVideoList
        .filter((item) => item.status === "OPEN")
        .map((item) => item.requestVideoDownloadId);

      setUserIdList((prevList) => Array.from(new Set([...prevList, ...allCurrentPageIds])));
    } else {
      const allCurrentPageIds = requestVideoList
        .filter((item) => item.status === "OPEN")
        .map((item) => item.requestVideoDownloadId);

      setUserIdList((prevList) => prevList.filter((id) => !allCurrentPageIds.includes(id)));
    }
  };

  const isAllChecked = () => {
    return requestVideoList
      .filter((item) => item.status === "OPEN")
      .every((item) => userIdList.includes(item.requestVideoDownloadId));
  };

  const handlePageChange = (pageNumber) => {
    let offsetNo = (pageNumber - 1) * itemsCountPerPage;
    setOffset(offsetNo);
    setActivePage(pageNumber);
    requestVideo("", offsetNo);
  };

  return (
    <div className='table-responsive ms-0 ms-md-4'>
      {totalCount > 0 &&
        <div className='text-end'>
          <button className='accept-all-btn' onClick={approveAll}>Approve All</button>
        </div>
      }
      <ToastContainer />
      {loading === false ?
        totalCount > 0 ?
          <>
            <table className="table table-bordered admin-list-table ">
              <thead>
                <tr>
                  <th className='position-relative'>#
                    {!requestVideoList.every((item) => item.status !== "OPEN") && (
                      <div className='checkbox-mark'>
                        <div className="checkbox-wrapper-1">
                          <input
                            id="example-1"
                            className="substituted sublist"
                            type="checkbox"
                            checked={isAllChecked()}
                            onChange={handleSelectAllChange}
                          />
                          <label htmlFor="example-1"></label>
                        </div>
                      </div>
                    )}
                  </th>
                  <th>Video / Image Title</th>
                  <th>Date</th>
                  <th style={{ whiteSpace: 'nowrap' }}>Requested By</th>
                  <th>Download Format</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {requestVideoList.map((data, i) => (
                  <tr className='position-relative' key={i}>
                    <td>
                      {(offset * 1) + i + 1}
                      {data.status === "OPEN" && (
                        <div className='checkbox-mark'>
                          <div className="checkbox-wrapper-1">
                            <input
                              id={`checkbox-${data.requestVideoDownloadId}`}
                              className="substituted"
                              type="checkbox"
                              checked={userIdList.includes(data.requestVideoDownloadId)}
                              onChange={(e) => handleCheckboxChange(e, data.requestVideoDownloadId)}
                            />
                            <label htmlFor={`checkbox-${data.requestVideoDownloadId}`}></label>
                          </div>
                        </div>
                      )}
                    </td>
                    <td> {data.fileTypeId == "1" ? (
                      <>
                        <FaRegImage /> {"  "}{data.videoName}
                      </>
                    ) : (
                      <><FaVideo />{"  "}{data.videoName}</>
                      
                    )}</td>
                    <td className='text-nowrap'>{moment(Number(data.requestedDate)).format('DD-MM-YYYY')}</td>
                    <td>{data.videorequestedbyname}</td>
                    <td> {data.status === "OPEN" &&
                      <div className="checkbox-wrapper-1 checkbox-list-select d-flex align-items-center gap-3 mt-2">
                        <div className='d-flex align-items-center gap-1'>
                          <input id={`originalVedioCheck-${data.requestVideoDownloadId}`} className="substituted" type="checkbox" aria-hidden="true"
                            checked={formatSelections[data.requestVideoDownloadId]?.download_original || false}
                            onChange={(e) => {
                              setFormatSelections(prev => ({
                                ...prev,
                                [data.requestVideoDownloadId]: {
                                  ...prev[data.requestVideoDownloadId],
                                  download_original: e.target.checked
                                }
                              }));
                            }}
                          />
                          <label className=" d-flex align-items-center" htmlFor={`originalVedioCheck-${data.requestVideoDownloadId}`}
                            style={{ fontSize: '12px' }}
                          >Original</label>
                        </div>
                        {data.fileTypeId == "2" &&
                          <div className='d-flex align-items-center gap-1'>
                            <input id={`mp4Check-${data.requestVideoDownloadId}`} className="substituted" type="checkbox" aria-hidden="true"
                              checked={formatSelections[data.requestVideoDownloadId]?.download_mp4 || false}
                              onChange={(e) => {
                                setFormatSelections(prev => ({
                                  ...prev,
                                  [data.requestVideoDownloadId]: {
                                    ...prev[data.requestVideoDownloadId],
                                    download_mp4: e.target.checked
                                  }
                                }));
                              }}
                            />

                            <label className=" d-flex align-items-center" htmlFor={`mp4Check-${data.requestVideoDownloadId}`}
                              style={{ fontSize: '12px' }}
                            >MP4</label>
                          </div>}
                      </div>}</td>
                    <td>
                      {data.status === "OPEN" ?
                        <select className="open" onChange={(e) => statusChangeFn([data.requestVideoDownloadId], e.target.value)}>
                          <option value={"OPEN"}>OPEN</option>
                          <option value={"APPROVED"}>APPROVE</option>
                          <option value={"REJECTED"}>REJECT</option>
                        </select>
                        :
                        <button className={`Modified ${data.status === `APPROVED` ? '' : `rejected`}`}>{data.status}</button>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {totalCount > itemsCountPerPage &&
              <div className='pagination-wrapper mt-4'>
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={itemsCountPerPage}
                  totalItemsCount={totalCount}
                  pageRangeDisplayed={itemsCountPerPage}
                  onChange={(e) => handlePageChange(e)}
                />
              </div>
            }
          </>
          :
          <div className="noData d-flex flex-column">
            <div>
              <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
            </div>
            <div>No Data Available</div>
          </div>
        :
        <div className="noData d-flex flex-column">
          <div>
            <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
          </div>
        </div>
      }
    </div>
  );
}

export default VideoDownloadRequest;